<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <TextModalForAgreement
      v-if="isModalActive"
      revisioned-content-title="プライバシーポリシー"
      :revisioned-content-url="privacyPolicyUrl"
      :revisioned-date="revisionedDate"
      :is-submittable="isSubmittable"
      @clicked-primary="clickAgreeButton"
    />
  </div>
</template>

<script>
import TextModalForAgreement from '../text-modal-for-agreement.vue'
import FeedbackSuccess from '../../../../components/atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../../../components/atoms/feedbacks/feedback-error.vue'
import axios from 'axios'
import { PRIVACY_POLICY_URL } from '../../../../constants/externalLinkConstants'

export default {
  components: {
    TextModalForAgreement,
    FeedbackSuccess,
    FeedbackError
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    },
    revisionedDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      privacyPolicyUrl: PRIVACY_POLICY_URL,
      isModalActive: true,
      showableSuccessFeedback: false,
      successMessage: '',
      showableErrorFeedback: false,
      errorMessage: '',
      isSubmittable: true
    }
  },
  mounted() {
    if (this.isApp) {
      // eslint-disable-next-line no-undef
      logEvent('privacy_modal_view')
    } else {
      dataLayer.push({
        event: 'privacy_modal_view'
      })
    }
  },
  methods: {
    closeModal() {
      this.isModalActive = false
    },
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    async clickAgreeButton() {
      this.isSubmittable = false

      if (this.isApp) {
        // eslint-disable-next-line no-undef
        logEvent('privacy_modal_click')
      } else {
        dataLayer.push({
          event: 'privacy_modal_click'
        })
      }
      try {
        const res = await axios.patch('/api/v1/privacy_policy_agreements/agree')
        if (res.data.status === 200) {
          this.closeModal()
          this.successMessage = 'プライバシーポリシーに同意しました'
          this.showableSuccessFeedback = true
        } else {
          this.errorMessage =
            'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
          this.showableErrorFeedback = true
          this.isSubmittable = true
        }
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        this.showableErrorFeedback = true
        this.isSubmittable = true
      }
    }
  }
}
</script>
